import { graphql } from 'gatsby';
import React from 'react';
import ArticlesSectionPre from '../components/molecules/articlesSectionPre/articlesSectionPre';
import ArticlesSections from '../components/molecules/articlesSections/articlesSections';
import BannerSections from '../components/molecules/bannerSections/bannerSections';
import ProductsSections from '../shared/components/molecules/productsSections/productsSections';
import PatternSection from '../components/organisms/patternsection/patternsection';
import Layout from '../shared/components/organisms/layout/layout';
import SEO from '../shared/components/seo';
import useBrowserMode from '../shared/hooks/useBrowserMode';
import useMobileMode from '../shared/hooks/useMobileMode';
import useLocaleMode from '../shared/hooks/useLocaleMode';

const HomeSegundoNivel = props => {

  const { isMobile, currentPage } = useMobileMode();
  const { isBrowser } = useBrowserMode();
  const parentNode = isBrowser && document.querySelector('body');
  const { locale } = useLocaleMode();
  React.useEffect(() => {
    if (parentNode.scrollTop > 0) {
      parentNode.scroll({
        top: 0,
        behavior: 'smooth',
      })
    }
  });

  const dataFiltered = props.pageContext;
  // const dataFiltered = props.data.allContentfulTenaHomeSegundoNivel.nodes.filter(node => node.slug === props.pageContext.slug)[0];

  return (
    <Layout isMobile={isMobile} currentPage={currentPage}>
      <SEO
        title={props.pageContext.metaTitulo} 
        description={props.pageContext.metaDescripcion.metaDescripcion}
        image={dataFiltered.banner?.bannerDesktop?.fluid?.src}
        slug={"/" + dataFiltered}
        lang={props.pageContext.language}
      />
      <article>
        <BannerSections isMobile={isMobile} bannerInfo={dataFiltered.banner} slug={dataFiltered.slug} />
        {props.pageContext.slug === 'cuidadores' ? (
          <>
            <ArticlesSectionPre title={dataFiltered.descripcionGeneral && dataFiltered.descripcionGeneral.descripcionGeneral} slug={dataFiltered.slug} isMobile={isMobile} articlesInfo={dataFiltered.referenciaTarjetasCuidadores} />
          </>
        ) : (
            <>
              <ArticlesSections title={dataFiltered.descripcionGeneral && dataFiltered.descripcionGeneral.descripcionGeneral} slug={dataFiltered.slug} isMobile={isMobile} articlesInfo={dataFiltered.articulos} ctaUrl={dataFiltered.ctaArticulosRedireccion} ctaTitle={!isMobile ? dataFiltered.ctaArticulos : dataFiltered.ctaArticulosMobile} />
              <ProductsSections isCurved={true} slug={props.pageContext.slug} isMobile={isMobile} productos={dataFiltered.productos} />
              {/* {locale === "es-CO" || locale === "es-PR" || locale === "es-DO" || locale === "es-PE" ?
              <PatternSection array={props.data.allContentfulTenaElementosDestacados.nodes} ismobile={isMobile} />
              :
              null
              } */}
            </>
          )}
      </article>
    </Layout>
  )
}

// export const query = graphql`
//   query GET_CONTENT_HOME_SECOND_LEVEL($language: String!) {
//     allContentfulTenaElementosDestacados(filter: {node_locale: {eq: $language}}) {
//       nodes {
//         imagenesCompletas {
//           file {
//             fileName
//             url
//           }
//         }
//         redireccion
//         elementosHtml{
//           nodeType
//           content {
//             content {
//               value
//             }
//           }
//         }
//       }
//     }
//   }
// `

export default HomeSegundoNivel;